import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { getTokenData } from "../../../../../services/Auth__Service";
import { findAllByClient } from "../../../../../services/Simulation__Services";
import navContext from "../../../../Context/navContext";
import notifyContext from "../../../../Context/notifyContext";
import Modal from "../../../../Modal/Modal";
import FormSimulation from "../FormSimulation/FormSimulation";
import BtnAddSimulation from "../BtnAdd/BtnAddSimulation";
import { frFR } from "@material-ui/data-grid";

const ListSimulation = () => {
  /* Handle Modal */
  const [viewSimulationId, setViewSimulationId] = useState(0);
  /* End Handle Modal */

  const [simulations, setSimulations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const nav = useContext(navContext);
  const notify = useContext(notifyContext);

  const columns = useMemo(
    () => [
      {
        field: "Date Envoie",
        headerName: "Envoyé le",
        type: "Date",
        width: 120,
        valueGetter: (params) => {
          return new Date(params.row.create_at).toLocaleDateString("fr-FR");
        },
      },

      {
        field: "Description",
        headerName: "Description",
        width: 120,
        flex: 1,
        valueGetter: (params) => {
          return params.row.description_resquest;
        },
      },

      {
        field: "Répondue le",
        headerName: "Répondue le",
        type: "Date",
        width: 120,
        valueGetter: (params) => {
          if (params.row.state)
            return new Date(params.row.last_modified).toLocaleDateString(
              "fr-FR"
            );
          else return null;
        },
      },

      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        width: 100,
        getActions: (params) => [
          <GridActionsCellItem
            icon={<MdOutlineRemoveRedEye />}
            label="Voir"
            onClick={() => setViewSimulationId(params.id)}
            // showInMenu
          />,
        ],
      },
    ],
    []
  );

  useEffect(() => {
    const data = getTokenData();
    nav({
      links: [
        {
          href: "/client/simulation",
          linkname: "Simulations",
        },
      ],
      children: <BtnAddSimulation />,
    });
    fetchAllSimulationByClient(data.user_id);
  }, []);

  const fetchAllSimulationByClient = async (id) => {
    findAllByClient(id)
      .then((response) => {
        setSimulations(response.data);
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleChangeRowsPerPage = (numberRow) => {
    setRowsPerPage(parseInt(numberRow, 10));
  };

  return (
    <Fragment>
      <div className="simulations__items">
        <div style={{ height: "100%", width: "100%", background: "#fff" }}>
          <DataGrid
            rows={simulations}
            columns={columns}
            pageSize={rowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
            loading={isLoading}
            onPageSizeChange={handleChangeRowsPerPage}
            localeText={frFR.props.MuiDataGrid.localeText}
          />
        </div>
      </div>

      {viewSimulationId !== 0 && (
        <Modal>
          <div className={`modal ${viewSimulationId !== 0 && "show"} `}>
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails Simulation</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewSimulationId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <FormSimulation simulationId={viewSimulationId} view={true} />
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewSimulationId(0)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

export default ListSimulation;
